var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.chartComponent,{tag:"component",attrs:{"feedTank":_vm.feedTank}})}
var staticRenderFns = []

export { render, staticRenderFns }